import React, { useEffect } from "react";
import {
  SUBSCRIPTION_PLANS,
  SUBSCRIPTION_STATUS,
} from "../../constants/constants";
import { useSelector, useDispatch } from "react-redux";
import { getRenewals } from "../../features/transaction/transactionSlice";
import moment from "moment";
import { BeatLoader } from "react-spinners";

const override = {
  display: "",
  margin: "0 auto",
  textAlign: "center",
  padding: "",
};

function PlanDescription({
  manageSubscription,
  addCredits,
  checkTransactions,
}) {
  const dispatch = useDispatch();
  const { organization } = useSelector((state) => state.organization);
  const currentPlan = organization?.subscriptionPlan;
  const isMonthly =
    currentPlan === "SUBSCRIPTION_1" || currentPlan === "SUBSCRIPTION_2";
  const { renewalDate } = useSelector((state) => state.transactions);

  useEffect(() => {
    if (currentPlan && currentPlan !== "TRIAL") {
      dispatch(getRenewals());
    }
  }, [dispatch, currentPlan]);

  return (
    <div className="card border-0 shadow-lg">
      <div className="card-body p-5">
        <div className="d-flex justify-content-between align-items-start mb-4">
          <div className="d-flex align-items-center">
            <div>
              <h2 className="fw-bold mb-1">
                {SUBSCRIPTION_PLANS[currentPlan]} {isMonthly && "(Monthly)"}
              </h2>
              <p className="mb-0 mt-2" style={{ fontSize: "0.98rem" }}>
                {isMonthly ? (
                  renewalDate ? (
                    <>
                      You are on a <strong>Monthly Plan</strong> and your next
                      charge will be on{" "}
                      {moment.unix(Number(renewalDate)).format("MMM D, YYYY")}
                    </>
                  ) : (
                    <BeatLoader
                      loading={true}
                      cssOverride={override}
                      color="var(--phoenix-emphasis-color)"
                      size="8px"
                    />
                  )
                ) : (
                  <></>
                )}
              </p>
            </div>
          </div>
          <div className="d-flex gap-2">
            <button
              onClick={() => checkTransactions()}
              type="submit"
              className="btn btn-primary d-flex align-items-center gap-2 mt-1"
            >
              <i
                className="wb webconnect-receipt"
                style={{ fontSize: "1rem" }}
              ></i>
              Transactions
            </button>
            <button
              onClick={() => manageSubscription()}
              type="submit"
              className="btn btn-primary d-flex align-items-center gap-2 mt-1"
            >
              <i
                className="wb webconnect-gear"
                style={{ fontSize: "1rem" }}
              ></i>
              Manage Subscription
            </button>
            <button
              onClick={() => addCredits()}
              type="button"
              className="btn btn-primary d-flex align-items-center gap-2 mt-1"
            >
              <i
                className="wb webconnect-plus-circle"
                style={{ fontSize: "1rem" }}
              ></i>
              Buy More Credits
            </button>
          </div>
        </div>
        <div className="mb-4" style={{ borderTop: "1px solid #2a2a3e" }}></div>
        <div
          className="card border border-translucent shadow-sm mt-2"
          style={{
            background: "rgba(255, 255, 255, 0.05)",
            backdropFilter: "blur(10px)",
            borderRadius: "14px",
            padding: "20px",
          }}
        >
          <div className="card-body p-4">
            <h5 className="fw-bold mb-1">Plan Details</h5>
            {currentPlan === "TRIAL" ? (
              <div className="d-flex justify-content-between align-items-center mt-4">
                You're on the trial plan 🚀 Subscribe for more features.
              </div>
            ) : (
              <>
                <div className="d-flex justify-content-between align-items-center mt-4">
                  <p className="mb-0" style={{ fontSize: "1rem" }}>
                    Credits (in your plan)
                  </p>
                  <span
                    className="badge rounded-pill bg-success"
                    style={{ fontSize: "16px" }}
                  >
                    {currentPlan === "SUBSCRIPTION_1"
                      ? "10,000 Tokens"
                      : "30,000 Tokens"}
                  </span>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-3">
                  <p className="mb-0" style={{ fontSize: "1rem" }}>
                    Status
                  </p>

                  <span
                    className={`badge rounded-pill ${
                      organization?.subscriptionStatus === "ACTIVE"
                        ? "bg-success"
                        : "bg-danger"
                    }`}
                    style={{ fontSize: "16px" }}
                  >
                    {SUBSCRIPTION_STATUS[organization?.subscriptionStatus]}
                  </span>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-3">
                  <p className="mb-0" style={{ fontSize: "1rem" }}>
                    Conversation Processing
                  </p>

                  <span
                    className="badge rounded-pill bg-success"
                    style={{ fontSize: "16px" }}
                  >
                    {currentPlan === "SUBSCRIPTION_1"
                      ? "Upto 200 hours"
                      : "Upto 500 hours"}
                  </span>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-3">
                  <p className="mb-0" style={{ fontSize: "1rem" }}>
                    Task Identification & creations
                  </p>

                  <span
                    className="badge rounded-pill bg-success"
                    style={{ fontSize: "16px" }}
                  >
                    {currentPlan === "SUBSCRIPTION_1"
                      ? "Upto 2,000 tasks"
                      : "Upto 6,000 tasks"}
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlanDescription;
